import { Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { useEffect, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { usePagination } from "~/components/hooks/usePagination"
import { SupplierProductionSites } from "~/pages/Brand/Suppliers/List/SupplierProductionSites/SupplierProductionSites.tsx"
import { useListSuppliersProductionSitesQuery } from "~/pages/Brand/Suppliers/List/supplierHooks.ts"

const SupplierProductionSitesWrapperContent = () => {
  const { cursorBasedPagination, pageBasedPagination, setPageBasedPagination } =
    usePagination()
  const [searchProductionSite, setSearchProductionSite] = useState<string>("")
  const [debouncedProductionSite] = useDebouncedValue<string>(
    searchProductionSite,
    600
  )
  useEffect(() => {
    setPageBasedPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedProductionSite, setPageBasedPagination])
  const productionSitesQuery = useListSuppliersProductionSitesQuery({
    fetchDataOptions: cursorBasedPagination,
    searchProductionSite: debouncedProductionSite,
  })

  return (
    <Stack gap="md">
      <DataFetchWrapper query={productionSitesQuery}>
        {({ data }) => (
          <Stack gap="xs">
            <SupplierProductionSites
              productionSitesData={data}
              setPagination={setPageBasedPagination}
              pagination={pageBasedPagination}
              searchProductionSites={searchProductionSite}
              setSearchProductionSites={setSearchProductionSite}
              debouncedProductionSites={debouncedProductionSite}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}

export const SupplierProductionSitesWrapper = () => {
  return (
    <HeaderControlsProvider>
      <SupplierProductionSitesWrapperContent />
    </HeaderControlsProvider>
  )
}
